import { useRelatiesGetRelationByRelatienummer } from '@services/crm-public/orval-api/relaties-api/relaties-api';
import type { MaybeRefOrGetter } from 'vue';
import { useRouteRelatienummer } from './route-relatienummer';

export function useRelatie(options?: {
  enabled?: MaybeRefOrGetter<boolean | undefined>;
  staleTime?: MaybeRefOrGetter<number>;
}) {
  const relatienummer = useRouteRelatienummer();

  return useRelatiesGetRelationByRelatienummer(relatienummer, {
    query: {
      ...options,
      select: ({ result }) => result,
    },
  });
}
